import script from "./DriveInformationDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./DriveInformationDialog.vue?vue&type=script&lang=ts&setup=true"

import "./DriveInformationDialog.vue?vue&type=style&index=0&id=2d8a59fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d8a59fa"]])

export default __exports__